import { scaleLinear as d3ScaleLinear, ScaleLinear } from 'd3-scale';

import { defaultTickFormatter } from '../formatters/defaultTickFormatter';

/**
 * A wrapper around d3's `scaleLinear` with enhancements around tick formatting
 */
export const scaleLinear = (locale?: string): ScaleLinear<number, number> => {
  const initScale = (baseScale: ScaleLinear<number, number>) => {
    const scale = baseScale;
    const originalCopy = baseScale.copy.bind(baseScale);

    scale.copy = () => {
      return initScale(originalCopy());
    };

    scale.tickFormat = () => (d) => defaultTickFormatter(d, locale);

    return scale;
  };

  return initScale(d3ScaleLinear());
};
